module.exports = __webpack_public_path__ + "static/media/Loader.cc40614c.gif";